module.exports = __webpack_public_path__ + "img/20.28f41bb3.png";